import { StarsButton } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import PointerIcon from '@swf/core/assets/icons/arrow.svg';
import ArrowIcon from '@swf/core/assets/icons/next.svg';

import styles from './styles.scss';

export interface Props {
  className?: string;
  variant?: 'arrow' | 'pointer';
  onClick?: () => void;
}

const BackButton: React.FC<Props> = ({ className, variant = 'arrow', onClick }) => (
  <StarsButton
    variant="text"
    size={variant === 'pointer' ? 'small' : 'large'}
    className={classNames(styles.back, styles[variant as keyof typeof styles], className)}
    icon={variant === 'arrow' ? <ArrowIcon /> : <PointerIcon width={20} height={20} />}
    onClick={onClick}
  />
);

export default BackButton;
